import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showDrawer: false,
};

const parrobotSlice = createSlice({
  name: 'parrobot',
  initialState,
  reducers: {
    toggleShow: (state) => {
      state.showDrawer = !state.showDrawer;
    },
    showDrawer: (state) => {
      state.showDrawer = true;
    },
    hideDrawer: (state) => {
      state.showDrawer = false;
    },
  },
});

// Export actions
export const { toggleShow, showDrawer, hideDrawer } = parrobotSlice.actions;

// Export selectors with descriptive name
export const isParrobotDrawerOpen = (state) => state.parrobot.showDrawer;

// Export reducer
export const parrobotReducer = parrobotSlice.reducer;
